import {
  EllipseMarker
} from "@/plugins/markerjs2";

export class EllipseMarker2 extends EllipseMarker {
  constructor(container, overlayContainer, settings) {
    super(container, overlayContainer, settings);
    this.fillColor = "transparent"
}
  getState() {
    const result = Object.assign(
      {
        fillColor: this.fillColor
      },
      super.getState()
    );
    result.typeName = EllipseMarker2.typeName;

    return result;
  }

  restoreState(state) {
    const ellipseState = state;
    this.fillColor = ellipseState.fillColor;
    super.restoreState(state);
  }
}

EllipseMarker2.typeName = "EllipseMarker2";
EllipseMarker2.title = "Ellipse Marker";
EllipseMarker2.icon = '<svg viewBox="0 0 24 24"><path d="M12 6c4.41 0 8 2.69 8 6s-3.59 6-8 6-8-2.69-8-6 3.59-6 8-6m0-2C6.5 4 2 7.58 2 12s4.5 8 10 8 10-3.58 10-8-4.5-8-10-8z"/></svg>';
